import React from 'react';
import classNames from 'classnames';
import './Skeleton.css';

export function Skeleton({ 
  width,
  height,
  circle = false,
  count = 1,
  className = '',
  ...props
}) {
  const skeletonClasses = classNames(
    'agrisense-skeleton',
    {
      'agrisense-skeleton--circle': circle,
    },
    className
  );

  const style = {
    width: width || '100%',
    height: height || (circle ? width : '20px'),
  };

  return (
    <>
      {Array.from({ length: count }).map((_, index) => (
        <div 
          key={index}
          className={skeletonClasses} 
          style={style}
          {...props}
        />
      ))}
    </>
  );
}